import { render, staticRenderFns } from "./CSVExport.vue?vue&type=template&id=584c7f56&scoped=true&"
import script from "./CSVExport.vue?vue&type=script&lang=ts&"
export * from "./CSVExport.vue?vue&type=script&lang=ts&"
import style0 from "./CSVExport.vue?vue&type=style&index=0&id=584c7f56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584c7f56",
  null
  
)

export default component.exports